export default "__VITE_ASSET__yc5wXj1r__"